import React from 'react';

export default function Loader() {
  return (
    <div className="flex flex-col justify-center items-center w-full bg-gray-50 rounded-2xl h-80">
      <div className="loader ease-linear rounded-full border-4 border-t-4 border-indigo-400 h-8 w-8"></div>
    </div>
  );
}
